import { useDateDisplayText } from '@/composables/UseDateDisplayText'

/**
 * ユーザーリスト表示項目(測位日時)の利用
 * @param {MaybeRef.<string>} at 測位日時
 * @param {MaybeRef.<string>} baseDate 基準日時
 */
export function useUserStatusAdditionalItemPositioning({ at, baseDate }) {
  const { formattedDate, diffText, text } = useDateDisplayText({
    date: at,
    baseDate,
  })
  return { formattedDate, diffText, text }
}
